// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3gjOd","content":"LayoutSettings_content__1F_dL"};